import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To replace any type of `}<inlineCode parentName="p">{`View`}</inlineCode>{` with a redacted version in the recording, set the `}<a parentName="p" {...{
        "href": "https://developer.android.com/reference/android/view/View#tags"
      }}>{`tag`}</a>{` to `}<inlineCode parentName="p">{`ph-no-capture`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<ImageView
    android:id="@+id/imvProfilePhoto"
    android:layout_width="200dp"
    android:layout_height="200dp"
    android:tag="ph-no-capture"
/>
`}</code></pre>
    <h3 {...{
      "id": "masking-in-jetpack-compose"
    }}>{`Masking in Jetpack Compose`}</h3>
    <ul>
      <li parentName="ul">{`You can manually mark a Compose View for masking using the `}<inlineCode parentName="li">{`postHogMask()`}</inlineCode>{` view modifier:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-android_kotlin"
      }}>{`...
    Text(
        text = AnnotatedString(text),
        modifier =
            modifier
                .wrapContentSize()
                .postHogMask()
                .clickable {
                    text = "Sensitive!"
                },
    )
...
`}</code></pre>
    <h3 {...{
      "id": "handling-sensitive-third-party-screens"
    }}>{`Handling sensitive third-party screens`}</h3>
    <p>{`Third-party components (like payment forms or authentication screens) are often rendered in separate view hierarchies that can't be accessed or modified for masking.`}</p>
    <p>{`For these cases, manually controlling the recording state is the only reliable solution. For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-android_kotlin"
      }}>{`// Stop session recording before showing a third-party payment sheet
PostHog.stopSessionReplay()

// Present third-party payment sheet
presentPaymentSheet()

// ... 
// Some time later when the sheet is dismissed, resume recording
PostHog.startSessionReplay()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      